import React from 'react'
import { Link } from 'react-router'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import * as s from './HomeView.scss'

const HomeView = () => {

    const contests = [
        { name: 'Football', detail: 'Weekly NFL picks', icon: 'football-ball', className: s.football },
        { name: 'Cinderella', detail: 'March bracket challenge', icon: 'basketball-ball', className: s.cinderella },
        { name: 'Eliminator', detail: 'Survive the NFL season', icon: 'shield-alt', className: s.eliminator },
        { name: 'Capture', detail: 'Own the tournament', icon: 'flag', className: s.capture },
        { name: 'Oscars', detail: 'Pick the award winners', icon: 'trophy', className: s.oscars },
    ]

    return (
        <main className={s.home}>
            <section className={s.hero}>
                <div className={s.heroContent}>
                    <div className={s.eyebrow}>Make your picks. Follow the action.</div>
                    <h1>A better way to play together.</h1>
                    <p className={s.intro}>
                        Friendly competition for every season—from Sunday football and
                        March brackets to Hollywood's biggest night.
                    </p>
                    <div className={s.actions}>
                        <Link className={s.primaryAction} to='/login'>
                            Log In <FontAwesomeIcon name='arrow-right' />
                        </Link>
                        <Link className={s.secondaryAction} to='/signup'>Create an Account</Link>
                    </div>
                    <p className={s.memberNote}>
                        Already part of a pool? Log in to make picks and see the latest standings.
                    </p>
                </div>

                <div className={s.heroVisual} aria-hidden='true'>
                    <div className={s.scoreCard + ' ' + s.scoreCardBack}>
                        <span>WEEK 12</span>
                        <strong>8–3</strong>
                    </div>
                    <div className={s.scoreCard + ' ' + s.scoreCardFront}>
                        <div className={s.cardTopline}>
                            <span>YOUR PICKS</span>
                            <span className={s.liveDot}>LIVE</span>
                        </div>
                        <div className={s.pickRow}>
                            <span className={s.teamMark}>RH</span>
                            <span><strong>Big game tonight</strong><small>Pick locked in</small></span>
                            <FontAwesomeIcon name='check-circle' />
                        </div>
                        <div className={s.cardProgress}><span /></div>
                        <div className={s.cardFooter}>
                            <span>Contest rank</span>
                            <strong>#4</strong>
                        </div>
                    </div>
                </div>
            </section>

            <section className={s.contestSection} aria-labelledby='contest-heading'>
                <div className={s.sectionHeading}>
                    <div>
                        <div className={s.eyebrow}>One home for every pool</div>
                        <h2 id='contest-heading'>There’s always something to pick.</h2>
                    </div>
                    <p>Join a contest, make your selections, and watch the standings unfold.</p>
                </div>

                <div className={s.contestGrid}>
                    {contests.map(contest => (
                        <article className={s.contestCard + ' ' + contest.className} key={contest.name}>
                            <span className={s.contestIcon}><FontAwesomeIcon name={contest.icon} /></span>
                            <div>
                                <h3>{contest.name}</h3>
                                <p>{contest.detail}</p>
                            </div>
                        </article>
                    ))}
                </div>
            </section>

            <section className={s.bottomCta}>
                <span className={s.bottomIcon}><FontAwesomeIcon name='users' /></span>
                <div>
                    <h2>Ready to get in the game?</h2>
                    <p>Your pools, picks, scores, and standings are waiting.</p>
                </div>
                <Link to='/login'>Go to Log In <FontAwesomeIcon name='arrow-right' /></Link>
            </section>
        </main>
    )
}

export default HomeView
